import EventAddons from "@app-contexts/public/shared/checkout/components/steps/add-ons/EventAddons/EventAddons.web";
import CheckoutBaseLayoutWithCart from "@app-contexts/public/shared/checkout/templates/CheckoutBaseLayoutWithCart/CheckoutBaseLayoutWithCart.web";
import { ContinueButton } from "@app-contexts/public/shared/checkout/components/ContinueButton/ContinueButton.web";
import CheckoutSummary from "@app-contexts/public/shared/checkout/components/CheckoutSummary/CheckoutSummary.web";
import DonationAddons from "./DonationAddons/DonationAddons.web";
import ProductAddons from "./product-add-ons/ProductAddons.web";

export default function Addons({
  hideContinueButton,
  modalHeight,
}: {
  hideContinueButton?: boolean;
  modalHeight?: string;
}): JSX.Element {
  return (
    <CheckoutBaseLayoutWithCart
      rightColumn={
        <CheckoutSummary
          callToActionButton={hideContinueButton ? null : <ContinueButton />}
        />
      }
    >
      <DonationAddons />

      <ProductAddons modalHeight={modalHeight} />

      <EventAddons modalHeight={modalHeight} />
    </CheckoutBaseLayoutWithCart>
  );
}
